export const CHANGE_PAGE = 'dictionary/CHANGE_PAGE';
export const CHANGE_SECTION = 'dictionary/CHANGE_SECTION';
export const CHANGE_LEVEL = 'dictionary/CHANGE_LEVEL';
export const UPDATE_WORDS = 'dictionary/UPDATE_WORDS'
export const PENDING_TRUE = 'textbook/PENDING_TRUE';
export const PENDING_FALSE = 'textbook/PENDING_FALSE';
export const FETCH_ERROR = 'textbook/FETCH_ERROR';

